import * as React from 'react';
import FlatButton from 'material-ui/FlatButton';
import {ActionBtnColor, TextColor} from '../../constants/generals';

export interface IFlatButtonProps {
    label;
    primary;
    color;
    onClick;
    backgroundColor?;
    buttonStyle?;
}

export class CustomFlatButton extends React.PureComponent<IFlatButtonProps, {}> {
    public render() {
        return <FlatButton
            labelStyle={{color: this.props.color}}
            label={this.props.label}
            backgroundColor={this.props.backgroundColor}
            style={{padding: this.props.buttonStyle}}
            primary={this.props.primary}
            onClick={this.props.onClick}
        />;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/CutomFlatButton.tsx